export default class makeDraggable {
    constructor() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                let dragObject = element[0];
                attrs.$set('draggable', 'true');

                dragObject.addEventListener('dragstart', (e) =>  {
                    e.stopPropagation();
                    scope.$emit('imageBank:dragStart');

                    if (attrs.imgMove) {
                        let imageId = $(dragObject).attr("data-id");
                        e.dataTransfer.setData('text', imageId);
                    } else if (! attrs.imgMove && attrs.draggableImage) {
                        e.dataTransfer.effectAllowed = 'copy';
                        e.dataTransfer.setData(
                            'text/html',
                            '<img src="' + attrs.draggableImage + '" width="' + attrs.imageWidth + '" height="' + attrs.imageHeight + '" >'
                        );
                    }
                });
            }
        }
    }
};
